import React from 'react';
import { ISigningCaseListItem } from 'src/models';
import { Table, TableHead, TableHeaderCell } from 'src/components';
import { t } from 'i18next';
import { SigningCasesListItemWithRouter } from 'src/components/AgreementsCard/SigningCasesList/SigningCasesListItem/SigningCasesListItem';

type ListType = 'Archived' | 'NotSigned' | 'Waiting';

interface Props {
  documents: ISigningCaseListItem[];
  type?: ListType;
  onClick?: (document: ISigningCaseListItem, index: number) => void;
}

export const SigningCasesList = ({ documents, type, onClick }: Props) => {
  const handleClick = (index: number, document: ISigningCaseListItem) => {
    if (onClick) onClick(document, index);
  };

  const handleKeyDown = (
    index: number,
    e: React.KeyboardEvent,
    document: ISigningCaseListItem
  ) => {
    if ((e.keyCode === 13 || e.keyCode === 32) && onClick) {
      onClick(document, index);
    }
  };

  const titleText =
    type === 'Archived' ? t('DateArchived') : t('DeadlineForSigning');

  return (
    <Table role="table" data-testid="data-testid">
      <TableHead role="head">
        <tr role="row">
          <TableHeaderCell role="columnheader" aria-label={t('Title')}>
            {t('Title')}
          </TableHeaderCell>
          <TableHeaderCell role="columnheader" aria-label={titleText}>
            {titleText}
          </TableHeaderCell>
          <TableHeaderCell role="columnheader" aria-label={t('Status')}>
            {t('Status')}
          </TableHeaderCell>
        </tr>
      </TableHead>
      <tbody role="rowgroup">
        {documents.map((document, index) => (
          <SigningCasesListItemWithRouter
            key={index}
            document={document}
            onClick={() => handleClick(index, document)}
            onKeyDown={e => handleKeyDown(index, e, document)}
          />
        ))}
      </tbody>
    </Table>
  );
};
